<template>
    <figure class="figure">
        <slot>
            <img
                loading="lazy"
                :src="src"
                :srcset="srcset"
                :sizes="sizes ? sizes : '100vw'"
                :alt="alt || ''"
                v-bind="$attrs"
            >
        </slot>

        <figcaption v-if="$slots.caption">
            <slot name="caption" />
        </figcaption>
    </figure>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: false,
            default: null
        },
        srcset: {
            type: String,
            required: false,
            default: null
        },
        sizes: {
            type: String,
            required: false,
            default: null
        },
        alt: {
            type: String,
            required: false,
            default: ''
        }
    }
};
</script>

<style lang="less">
.figure {
    display: block;
    text-decoration: none;
    height: 100%;
    line-height: 0;

    img {
        width: 100%;
        object-fit: contain;
    }
}
</style>
